<script>
  import { onMount } from "svelte";
  import axios from "axios";
  import { link } from "svelte-spa-router";
  import Layout from "../../Layout/Layout.svelte";
  import MenuHeading from "../../shared/MenuHeading.svelte";
  import config from "../../stores/config";
  import { Circle } from "svelte-loading-spinners";
  import * as ls from "local-storage";

  export let params;
  let uploading = false;
  let loading = true;

  let name = null;
  let price = null;
  let inventoryLevel = null;
  let size = null;
  let SKU = null;
  let description = null;
  let patternID = null;
  let patternPieces = null;
  let costingN = null;
  let contrast = null;

  onMount(() => {
    axios
      .get(`${$config.backendURL}/fstyles/${params.id}`)
      .then((res) => {
        name = res.data.name;
        price = res.data.price;
        inventoryLevel = res.data.inventoryLevel;
        size = res.data.size;
        SKU = res.data.SKU;
        description = res.data.description;
        patternID = res.data.patternID;
        patternPieces = res.data.patternPieces;
        costingN = res.data.costingN;
        contrast = res.data.contrast;
        loading = false;
      })
      .catch((err) => {
        console.log(err);
      });
  });

  const handleClear = () => {
    name = null;
    price = null;
    inventoryLevel = null;
    size = null;
    SKU = null;
    description = null;
    patternID = null;
    patternPieces = null;
    costingN = null;
    contrast = null;
  };

  const handleSubmit = async (e) => {
    // if (name) SKU = genSKU(name);
    if (!name) alert("Style Name Missing");
    else if (!price) alert("Price missing!");
    else if (inventoryLevel == undefined) alert("Inventory Level missing!");
    else if (!size) alert("Size missing!");
    else if (!SKU) alert("SKU missing!");
    else {
      uploading = true;

      let data = {
        name,
        price,
        inventoryLevel,
        size,
        SKU,
        description,
        patternID,
        patternPieces,
        costingN,
        contrast,
      };

      axios
        .put(`${$config.backendURL}/fstyles/${params.id}`, data, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          console.log(res.data);
          uploading = false;
          alert(`☑ Updated Successfully`);
          window.location.reload();
        })
        .catch((err) => {
          alert("There was a problem, Refresh the page and retry");
          console.log(err);
          uploading = false;
        });
    }
  };
</script>

<svelte:head>
  <title>Edit Style | Fabi CC System</title>
</svelte:head>

<Layout>
  <MenuHeading
    title="Edit Style"
    description="Fill out the form below to edit styles. All fields are REQUIRED."
  />

  <div class="flex justify-end mb-6">
    <a class="ml-3 btn btn-green-outline" use:link href="/fstyles">
      <i class="fas fa-arrow-left mr-3" />
      Return to Styles Database
    </a>
  </div>

  {#if loading}
    <div class="h-52 w-full flex items-center justify-center">
      <Circle size="50" color="rgb(16, 185, 129)" unit="px" />
    </div>
  {:else}
    <form
      on:submit|preventDefault={handleSubmit}
      class="grid grid-cols-1 gap-y-4 text-gray-500 pb-8"
    >
      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Style Name :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={name}
            placeholder="Style Name"
          />
        </div>
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Unit Price :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="number"
            step="any"
            bind:value={price}
            placeholder="Unit Price"
          />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Inventory Level :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="number"
            step="any"
            bind:value={inventoryLevel}
            placeholder="This field is not compulsory"
          />
        </div>
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>SKU :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={SKU}
            placeholder="SKU"
            required
          />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Pattern ID :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={patternID}
            placeholder="Pattern ID"
          />
        </div>
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Pattern Pieces :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={patternPieces}
            placeholder="Pattern Pieces"
          />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Size :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={size}
            placeholder="Size"
            required
          />
        </div>
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Costing Number :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={costingN}
            placeholder="Costing Number"
            required
          />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Contrast [Optional]:</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={contrast}
            placeholder="Contrast"
          />
        </div>
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Description :</div>
          <textarea
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={description}
            placeholder="Description"
            rows="2"
          />
        </div>
      </div>

      {#if uploading}
        <div class="grid grid-cols-1 gap-8">
          <div class="flex items-center justify-center btn btn-green-outline">
            <Circle size="25" color="rgb(16, 185, 129)" unit="px" />
            <span class="ml-4">Please wait...</span>
          </div>
        </div>
      {:else}
        <div class="grid grid-cols-2 gap-8">
          <button class="btn btn-green-outline" on:click={handleClear}>
            <i class="fas fa-times-circle mr-3" />
            Clear Form
          </button>
          <button on:click={handleSubmit} class="btn btn-green">
            <i class="fas fa-check-circle mr-3" />
            Save to Database
          </button>
        </div>
      {/if}
    </form>
  {/if}
</Layout>
